import styled, { css } from 'styled-components';

import Tooltip from '../../Tooltip';

interface ContainerProps {
  isFocused: boolean;
  isField: boolean;
  isErrored: boolean;
}

export const Container = styled.div<ContainerProps>`
	display: flex;
  align-items: center;
  background: #fff;
  border-radius: 7px;
  border: 1px solid #b0bec5;
  padding: 10px;
  width: 100%;
  color: #455a64;

  & + div {
    margin-top: 8px;
  }

  ${props =>
    props.isErrored &&
    css`
      border-color: #c53030;
    `}

  ${props =>
    props.isFocused &&
    css`
      color: var(--azul-razio);
      border-color: var(--azul-razio);
    `}

  ${props =>
    props.isField &&
    css`
      color: var(--azul-razio);
    `}

	input[type="date"]::-webkit-datetime-edit-text,
	input[type="date"]::-webkit-datetime-edit-day-field,
	input[type="date"]::-webkit-datetime-edit-month-field,
	input[type="date"]::-webkit-datetime-edit-year-field  {
		color: #90a4ae;
	}

	input[type="date"].date-input--has-value::-webkit-datetime-edit-text,
	input[type="date"].date-input--has-value::-webkit-datetime-edit-month-field,
	input[type="date"].date-input--has-value::-webkit-datetime-edit-day-field,
	input[type="date"].date-input--has-value::-webkit-datetime-edit-year-field {
		color: #333;
	}

	input[type='date']::-webkit-calendar-picker-indicator {
    margin-left: 0;
  }

  input {
    flex: 1;
		width: 100%;
    background: transparent;
    border: 0;
    color: #333;
		font-weight: 500;
		padding-right: 10px;
		cursor: pointer;

    > svg {
      margin-left: 0 !important;
      padding-left: 0 !important;
			cursor: pointer;
    }

    :focus {
      box-shadow: 0 0 0 0;
      border: 0 none;
      outline: 0;
    }
  }

	// 479px
  @media (max-width: 29.9375rem) {
		input {
			// font-size: 14px;
			height: 25px;
		}
	}
`;

export const Error = styled(Tooltip)`
  height: 20px;
  margin-left: 16px;

  svg {
    margin: 0;
  }

  span {
    background: #c53030;
    color: #fff !important;

    &::before {
      border-color: #c53030 transparent;
    }
  }
`;
